import { blue, green, purple, shade, yellow } from '../../../colors'
import { type DisplaySettings } from '../../../hooks/useDisplaySettings'
import * as yup from 'yup'

export enum CellField {
  INSTRUCTIONDETAILS = 'instructorDetails',
}

export enum CategoryKey {
  SECTION = 'Section',
  HIDETABLE = 'hideTable',
}

export enum KeyStatType {
  AVERAGE = 'Average',
  TOP_2 = 'Top 2',
  BOTTOM_2 = 'Bottom 2',
  STANDARD_DEVIATION = 'Standard Deviation',
  MEDIAN = 'Median',
  MODE = 'Mode',
}

export const keyStatSwitches: Array<{ label: string, name: keyof DisplaySettings }> = [
  { label: 'Average', name: 'average' },
  { label: 'Median', name: 'median' },
  { label: 'Mode', name: 'mode' },
  { label: 'Top 2', name: 'top2' },
  { label: 'Bottom 2', name: 'bottom2' },
  { label: 'Standard Deviation', name: 'stdev' }
]

export const chartSettingsSwitches: Array<{ label: string, name: keyof DisplaySettings }> = [
  { label: 'Display Percentage', name: 'percentage' }
]

export const barColors = [blue[600], shade[850], green[250], green[700], yellow[150], yellow[450], purple[300], purple[700]]

export const comparisonSchema = yup.object({
  comparisons: yup.array().of(
    yup.object({
      compareBy: yup.string().nullable(),
      comparison: yup.string().nullable().when('compareBy', {
        is: (val: string | null) => !!val,
        then: schema => schema.required('Select an Academic Unit to continue'),
        otherwise: schema => schema.nullable()
      })
    })
  ).required(),
  slices: yup.array().of(
    yup.object({
      sliceBy: yup.string().nullable()
    })
  ).required(),
  keyStatistics: yup.object(
    keyStatSwitches.reduce<Record<string, yup.BooleanSchema>>((acc, { name }) => {
      acc[name] = yup.boolean()
      return acc
    }, {})
  ).required(),
  chartSettings: yup.object(
    chartSettingsSwitches.reduce<Record<string, yup.BooleanSchema>>((acc, { name }) => {
      acc[name] = yup.boolean()
      return acc
    }, {})
  ).required()
})
